import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ErrorDisplayService} from '../../../basic-entity-front/services/error-display.service';
import {ConversacionesService} from '../conversaciones.service';
import {ComunicadoResumen} from '../conversaciones.model';

export interface DatosAvisoComunicados {
    /** No leídos, más reciente primero (los ordena ComunicadosAvisoService.revisar()). */
    comunicados: ComunicadoResumen[];
}

/**
 * Aviso al entrar con los comunicados de CNC Dental que todavía no se han leído. Lo abre
 * ComunicadosAvisoService.revisar() con `disableClose: true` (ni ESC ni clic fuera lo cierran): la
 * salida normal es «Entendido», que marca todos como leídos y cierra. Si la llamada falla, se enseña
 * el error Y aparece un «Cerrar» secundario (ver plantilla, `*ngIf="fallo"`) que cierra sin marcar
 * nada leído: los mismos no leídos volverán a salir en la próxima carga de la app. Sin esa salida, un
 * fallo persistente (red caída, API abajo) dejaría al cliente sin poder usar el resto de la SPA.
 *
 * marcarComunicadosLeidos() no emite `cambios$` a propósito (lo documenta el propio servicio, igual
 * que marcarLeida() de conversaciones): si la bandeja /mensajes está abierta en otra pestaña o detrás
 * de este diálogo, sus comunicados se quedarían con el punto de no leído hasta la próxima recarga. Al
 * cerrar con éxito disparamos aquí `cambios$.next()` (el Subject es público, como ya hace el aviso
 * por Mercure) para que esas listas se recarguen en silencio sin tocar el servicio.
 */
@Component({
    selector: 'app-comunicados-aviso-dialog',
    templateUrl: './comunicados-aviso-dialog.component.html',
    styleUrls: ['./comunicados-aviso-dialog.component.scss']
})
export class ComunicadosAvisoDialogComponent {
    enviando = false;
    /** «Entendido» ha fallado al menos una vez: aparece el «Cerrar» secundario. */
    fallo = false;

    constructor(public dialogRef: MatDialogRef<ComunicadosAvisoDialogComponent>,
                @Inject(MAT_DIALOG_DATA) public data: DatosAvisoComunicados,
                private _conversaciones: ConversacionesService, private _errores: ErrorDisplayService) {
    }

    entendido(): void {
        this.enviando = true;
        this._conversaciones.marcarComunicadosLeidos(this.data.comunicados.map(c => c.id)).subscribe({
            next: () => {
                this._conversaciones.cambios$.next();
                this.dialogRef.close();
            },
            error: e => {
                this.enviando = false;
                this.fallo = true;
                this._errores.displayError(e);
            }
        });
    }

    /** Solo disponible tras un fallo de «Entendido» (ver `fallo`): cierra sin marcar nada leído. */
    cerrarSinMarcar(): void {
        this.dialogRef.close();
    }
}
